window.on = function (eventName, selector, handler) {
	$(document).on(eventName, selector, handler);
};
